import { Box, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

const AdminBreadcrumbBar = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const separator = <Typography sx={{ opacity: 0.4, mx: 0.5 }}>/</Typography>

  const getPageLabel = () => {
    if (location.pathname.startsWith('/adminReports')) return 'Rapports'
    return null
  }

  const pageLabel = getPageLabel()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        ml: { xs: 1, md: 2 },
        mr: { xs: 1, md: 2 },
        flexWrap: 'nowrap',
      }}
    >
      <Typography
        sx={{
          opacity: pageLabel ? 0.7 : 1,
          fontWeight: pageLabel ? 400 : 500,
          fontSize: '1rem',
          cursor: pageLabel ? 'pointer' : 'default',
          '&:hover': pageLabel ? { opacity: 1 } : {},
        }}
        onClick={pageLabel ? () => navigate('/admin') : undefined}
      >
        Tableau de bord administratif
      </Typography>

      {pageLabel && (
        <>
          {separator}
          <Typography sx={{ opacity: 1, fontWeight: 500, fontSize: '1rem', whiteSpace: 'nowrap' }}>
            {pageLabel}
          </Typography>
        </>
      )}
    </Box>
  )
}

export default AdminBreadcrumbBar
